import { ClientIntegration } from "@avenueops/shared-types";
import { SmartForm } from "@avenueops/web-components";

interface Props {
  notificationPrefix: string;
  hubSpotIntegrations: ClientIntegration[];
}

export function HubSpotNotificationInput({ notificationPrefix, hubSpotIntegrations }: Props) {
  return (
    <div className="col-span-4">
      <SmartForm.DropdownSelect
        name={`${notificationPrefix}.integrationId`}
        defaultValue={hubSpotIntegrations.length === 1 ? hubSpotIntegrations[0].integrationId : undefined}
        title="Integration Instance"
        options={hubSpotIntegrations.map((integration) => ({
          label: integration.name ?? "HubSpot integration",
          value: integration.integrationId,
        }))}
      />

      <div className="pt-5"></div>
      <SmartForm.TextInput title="Base URL" name={`${notificationPrefix}.recipientValue`} required={true} placeholder="https://api.hubapi.com/" />
    </div>
  );
}
